var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"dark":"","label":"","x-small":"","color":_vm.userData.department.toLowerCase()}},[(_vm.fullName)?[_vm._v(" "+_vm._s(_vm._f("FullName")(_vm.userData))+" ")]:[_vm._v(" "+_vm._s(_vm._f("Initials")(_vm.userData))+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }